module.exports = function() {
  return new Worker(__webpack_public_path__ + "5b354a84251322028d97.worker.js");
};